(function (angular) {
    'use strict';

    angular
        .module('app.directory')
        .controller('app.directory.controller', ['$scope', '$http', '$filter', directoryController]);

    function directoryController($scope, $http, $filter) {
        var vm = this;
        vm.triggerAc = triggerAc;
        vm.triggerClick = triggerClick;
        var markers = new Array();
        vm.siteContent = siteContent;
        vm.resetMap = resetMap;

        var geocoder;
        var map;
        var bounds;
        var autocomplete;
        var countryRestrict = { 'country': 'us' };
        var addressData = [];
        var originalAddressData = [];
        var infoWindows = [];
        var visibleListings = [];
        var milesSelection = 5;
        var boundChangeListener = null;

        $scope.hasMinZoom = false;
        $scope.initialLoading = true;

        // get practices
        var apiUrl = environment.treatmentApiDirectUrl + 'practices/get-directory';
        $http.post(apiUrl, { planName: vm.siteContent.planNamePrefix }).then(function (response) {
            originalAddressData = response.data.entries;
            $scope.originalAddressData = originalAddressData;
            $scope.addressData = addressData;
            $scope.initialLoading = false;
            initializeMap();
        });

        // initialize the map
        function initializeMap() {
            // map setup + settings
            map = new google.maps.Map(document.getElementById('map_canvas'), {
                zoom: 13,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false
            });

            addsBoundChangeListener();

            map.setOptions({ maxZoom: 18, zoom: 5, center: new google.maps.LatLng(39.4515876, -97.1658519) });
            bounds = new google.maps.LatLngBounds();
            $scope.fullAddress = [];

            autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
                componentRestrictions: countryRestrict
            });

            // pass addresses to geocode addressData
            function getPoints() {
                let locationData = [];
                let addressLocations = [];

                if (originalAddressData) {
                    for (let i = 0; i < originalAddressData.length; i++) {
                        var lineTwo = '';
                        if (originalAddressData[i].address.line2) {
                            lineTwo = ' ' + originalAddressData[i].address.line2;
                        }

                        $scope.originalAddressData[i].id = i;

                        // convert address object to string
                        $scope.fullAddress.push(
                            originalAddressData[i].address.line1 +
                                lineTwo +
                                ', ' +
                                originalAddressData[i].address.city +
                                ', ' +
                                originalAddressData[i].address.state +
                                ' ' +
                                originalAddressData[i].address.zipCode
                        );

                        if (
                            originalAddressData[i].latitude &&
                            originalAddressData[i].latitude !== null &&
                            originalAddressData[i].longitude &&
                            originalAddressData[i].longitude !== null
                        ) {
                            if (
                                map.getBounds() &&
                                map.getBounds().contains({
                                    lat: originalAddressData[i].latitude,
                                    lng: originalAddressData[i].longitude
                                })
                            ) {
                                if (
                                    markers.filter(function (m) {
                                        return (
                                            m.position.lat() == originalAddressData[i].latitude &&
                                            m.position.lng() == originalAddressData[i].longitude
                                        );
                                    }).length === 0
                                ) {
                                    addressLocations.push({
                                        address: originalAddressData[i],
                                        location: [originalAddressData[i].latitude, originalAddressData[i].longitude],
                                        distance: haversine_distance(
                                            map.getCenter(),
                                            new google.maps.LatLng(
                                                originalAddressData[i].latitude,
                                                originalAddressData[i].longitude
                                            )
                                        )
                                    });
                                }
                            }
                        }
                    }
                }

                addressLocations = addressLocations.sort(function (a, b) {
                    if (a.distance < b.distance) {
                        return -1;
                    }
                    if (a.distance > b.distance) {
                        return 1;
                    }
                    return 0;
                });

                for (var i = 0; i < addressLocations.length; i++) {
                    addressData.push({ index: addressData.length, data: addressLocations[i].address });
                    locationData.push(addressLocations[i].location);
                }

                $scope.addressData = addressData;
                return locationData;
            }

            function haversine_distance(mk1, mk2) {
                var R = 3958.8; // Radius of the Earth in miles
                var rlat1 = mk1.lat() * (Math.PI / 180); // Convert degrees to radians
                var rlat2 = mk2.lat() * (Math.PI / 180); // Convert degrees to radians
                var difflat = rlat2 - rlat1; // Radian difference (latitudes)
                var difflon = (mk2.lng() - mk1.lng()) * (Math.PI / 180); // Radian difference (longitudes)

                var d =
                    2 *
                    R *
                    Math.asin(
                        Math.sqrt(
                            Math.sin(difflat / 2) * Math.sin(difflat / 2) +
                                Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)
                        )
                    );
                return d;
            }

            initAutocomplete();

            function addsBoundChangeListener() {
                boundChangeListener = google.maps.event.addListener(map, 'bounds_changed', function () {
                    var zoomLevel = map.getZoom();

                    if (zoomLevel >= 10) {
                        if (!$scope.hasMinZoom) {
                            markers = new Array();
                            infoWindows = [];
                            addressData = [];
                            $scope.addressData = [];
                        }

                        $scope.hasMinZoom = true;
                        createMarkers(getPoints());
                        for (var i = 0; i < markers.length; i++) {
                            if (map.getBounds().contains(markers[i].getPosition())) {
                                $scope.addressData[i].data.hide = true;
                            } else {
                                $scope.addressData[i].data.hide = false;
                            }
                        }
                    } else {
                        if ($scope.hasMinZoom) {
                            for (var i = 0; i < markers.length; i++) {
                                markers[i].setMap(null);
                            }

                            markers = new Array();
                            infoWindows = [];
                            addressData = [];
                            $scope.addressData = [];
                            $scope.hasMinZoom = false;
                        }
                    }

                    $scope.$apply();
                });
            }

            function initAutocomplete() {
                var options = {
                    types: ['geocode']
                };

                autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), options);
                google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged);
            }

            // on autocomplete input change
            function onPlaceChanged() {
                var place = autocomplete.getPlace();
                if (place) {
                    if (!place.geometry || place.name !== document.getElementById('autocomplete').value) {
                        geocoder = new google.maps.Geocoder();
                        geocoder.geocode(
                            { 'address': document.getElementById('autocomplete').value },
                            function (results, status) {
                                if (status == 'OK') {
                                    var address = getTheUSAddress(results);
                                    placeCenter(address.geometry);
                                } else {
                                    return;
                                }
                            }
                        );
                    } else {
                        placeCenter(place.geometry);
                    }
                } else {
                    document.getElementById('autocomplete').placeholder = 'Enter a city';
                }
            }

            function getTheUSAddress(results) {
                for(var i = 0; i < results.length; i++) {
                    if (results[i].address_components[results[i].address_components.length - 1].short_name == 'US') {
                        return results[i];
                    }
                }

                return results[0];
            }

            function placeCenter(geometry) {
                for (var i = 0; i < infoWindows.length; i++) {
                    infoWindows[i].close();
                }

                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }

                markers = new Array();
                infoWindows = [];
                addressData = [];
                $scope.addressData = [];
                $scope.hasMinZoom = false;

                var placeCoords = new google.maps.LatLng(geometry.location.lat(), geometry.location.lng());

                if (boundChangeListener !== null) {
                    google.maps.event.removeListener(boundChangeListener);
                }

                map.setZoom(10);
                map.setCenter(placeCoords);
                addsBoundChangeListener();
                google.maps.event.trigger('bounds_changed');

                scrollTo(document.getElementById('dentists-listings'), 0, 400, i);
            }

            // pan to user's location on map if geolocation is turned on
            function geolocate() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        var geolocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        console.log('Your geolocation is: ' + geolocation.lat + ' ' + geolocation.lng);

                        if (position) {
                            var userCoords = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );
                            if (boundChangeListener !== null) {
                                google.maps.event.removeListener(boundChangeListener);
                            }

                            map.setZoom(10);
                            map.setCenter(userCoords);
                            addsBoundChangeListener();
                            google.maps.event.trigger('bounds_changed');
                        }
                    });
                }
            }

            function createMarkers(returnVals) {
                if (!returnVals || returnVals.length === 0) {
                    return;
                }

                returnVals = returnVals.filter(function (rv) {
                    return rv !== null && rv.data !== null;
                });
                returnVals.forEach(function (latLng, index) {
                    var i = markers.length;
                    var iconNumber = markers.length + 1;
                    var mapIcon = {
                        scaledSize: new google.maps.Size(39, 54),
                        url:
                            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='39px' height='54px' viewBox='0 0 39 54' version='1.1'%3E%3C!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3E%3Ctitle%3EGroup 13%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Welcome' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Desktop-HD-Copy' transform='translate(-805.000000, -662.000000)'%3E%3Cg id='Group-13' transform='translate(805.000000, 662.000000)'%3E%3Cg id='Group-11'%3E%3Cg id='Oval-2' transform='translate(10.000000, 10.000000)' fill='%23FFFFFF' stroke='%23979797'%3E%3Ccircle id='Oval' cx='9.5' cy='9.5' r='9.5'/%3E%3C/g%3E%3Cg id='Group-12'%3E%3Cg xmlns='http://www.w3.org/2000/svg' id='iconfinder_94_171453' fill='%23" +
                            vm.siteContent.site.pages.directory.iconColor +
                            "' text-anchor='middle' fill-rule='nonzero'%3E%3Cg id='Shape-2'%3E%3Cpath d='M28.7368421,19.7307692 C28.7368421,24.8906788 24.60136,29.0769231 19.5,29.0769231 C14.3979138,29.0769231 10.2631579,24.8906788 10.2631579,19.7307692 C10.2631579,14.5693833 14.39864,10.3846154 19.5,10.3846154 C24.6024493,10.3842463 28.7368421,14.5690142 28.7368421,19.7307692 M39,19.6364694 C39,8.79133788 30.2700926,0 19.5,0 C8.73067398,0 0,8.79133788 0,19.6364694 C0,24.4047446 1.68948641,28.7767622 4.49699275,32.1775218 L19.5168642,54 L34.7563536,31.8591974 C35.3036736,31.1694298 35.8050003,30.4424404 36.2572675,29.6782291 L36.411345,29.4556734 L36.3860487,29.4556734 C38.0456395,26.5655511 39,23.2148083 39,19.6364694' id='Shape'/%3E%3C/g%3E%3C/g%3E%3Ctext xmlns='http://www.w3.org/2000/svg' id='97' font-family='Sans-Serif' font-size='12' width='30px' font-weight='bold' letter-spacing='-0.133333335' fill='%23737373' style='&%2310;'%3E%3Ctspan xmlns='http://www.w3.org/2000/svg' x='19.1' text-anchor='middle' y='24' style='&%2310;'%3E" +
                            iconNumber +
                            '%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E'
                    };
                    var marker = new google.maps.Marker({
                        position: { lat: latLng[0], lng: latLng[1] },
                        map: map,
                        title: addressData[i].data.title,
                        icon: mapIcon,
                        optimized: false,
                        animation: google.maps.Animation.DROP
                    });

                    // conditional url on infowindow
                    var site = '';
                    if (addressData[i].data.url) {
                        site =
                            "<div class='iw-site'> \
                                    <a href='" +
                            addressData[i].data.url +
                            "' target=_blank>Website</a> \
                                </div>";
                    }

                    var phone = $filter('phone')(addressData[i].data.phone);

                    var pin =
                        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='12px' height='16.9px' viewBox='0 0 39 54' version='1.1'%3E%3C!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3E%3Ctitle%3EGroup 5%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Welcome' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Desktop-HD' transform='translate(-721.000000, -550.000000)'%3E%3Cg id='Group-5' transform='translate(721.000000, 550.000000)'%3E%3Cpath d='M28.7368421,19.7307692 C28.7368421,24.8906788 24.60136,29.0769231 19.5,29.0769231 C14.3979138,29.0769231 10.2631579,24.8906788 10.2631579,19.7307692 C10.2631579,14.5693833 14.39864,10.3846154 19.5,10.3846154 C24.6024493,10.3842463 28.7368421,14.5690142 28.7368421,19.7307692 M39,19.6364694 C39,8.79133788 30.2700926,0 19.5,0 C8.73067398,0 0,8.79133788 0,19.6364694 C0,24.4047446 1.68948641,28.7767622 4.49699275,32.1775218 L19.5168642,54 L34.7563536,31.8591974 C35.3036736,31.1694298 35.8050003,30.4424404 36.2572675,29.6782291 L36.411345,29.4556734 L36.3860487,29.4556734 C38.0456395,26.5655511 39,23.2148083 39,19.6364694' id='Shape' fill='%23" +
                        vm.siteContent.site.pages.directory.iconColor +
                        "' fill-rule='nonzero'/%3E%3Cg id='Oval-2' transform='translate(10.000000, 10.000000)' fill='%23FFFFFF' stroke='%23979797'%3E%3Ccircle id='Oval' cx='9.5' cy='9.5' r='9.5'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E";

                    var addressFull =
                        addressData[i].data.address.line1 +
                        (addressData[i].data.address.line2 ? ' ' + addressData[i].data.address.line2 : '') +
                        '<br />' +
                        addressData[i].data.address.city +
                        ', ' +
                        addressData[i].data.address.state +
                        ' ' +
                        addressData[i].data.address.zipCode;

                    // format infowindow
                    var infowindowContent =
                        "<div class='iw-content'> \
                                                <div class='iw-title'>" +
                        addressData[i].data.title +
                        "</div> \
                                                <div class='iw-address'>" +
                        addressFull +
                        "</div> \
                                                <div class='iw-phone-dir'> \
                                                    <div class='iw-phone'> \
                                                        <a href='tel:" +
                        addressData[i].data.phone +
                        "'>" +
                        phone +
                        "</a> \
                                                    </div> \
                                                    <div class='iw-dir'> \
                                                        <a href='http://maps.google.com/?q=" +
                        addressFull.replace('<br />', ', ') +
                        '\' target=_blank> \
                                                            <img src="' +
                        pin +
                        '"> \
                                                            Get Directions \
                                                        </a> \
                                                    </div> \
                                                </div>' +
                        site +
                        ' \
                                            </div>';

                    var infowindow = new google.maps.InfoWindow({
                        content: infowindowContent
                    });

                    infoWindows.push(infowindow);

                    var activeIcon = {
                        scaledSize: new google.maps.Size(45, 63),
                        url:
                            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='45px' height='63px' viewBox='0 0 39 54' version='1.1'%3E%3C!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3E%3Ctitle%3EGroup 13%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Welcome' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Desktop-HD-Copy' transform='translate(-805.000000, -662.000000)'%3E%3Cg id='Group-13' transform='translate(805.000000, 662.000000)'%3E%3Cg id='Group-11'%3E%3Cg id='Oval-2' transform='translate(10.000000, 10.000000)' fill='%23FFFFFF' stroke='%23979797'%3E%3Ccircle id='Oval' cx='9.5' cy='9.5' r='9.5'/%3E%3C/g%3E%3Cg id='Group-12'%3E%3Cg xmlns='http://www.w3.org/2000/svg' id='iconfinder_94_171453' fill='%23" +
                            vm.siteContent.site.pages.directory.iconColor +
                            "' text-anchor='middle' fill-rule='nonzero'%3E%3Cg id='Shape-2'%3E%3Cpath d='M28.7368421,19.7307692 C28.7368421,24.8906788 24.60136,29.0769231 19.5,29.0769231 C14.3979138,29.0769231 10.2631579,24.8906788 10.2631579,19.7307692 C10.2631579,14.5693833 14.39864,10.3846154 19.5,10.3846154 C24.6024493,10.3842463 28.7368421,14.5690142 28.7368421,19.7307692 M39,19.6364694 C39,8.79133788 30.2700926,0 19.5,0 C8.73067398,0 0,8.79133788 0,19.6364694 C0,24.4047446 1.68948641,28.7767622 4.49699275,32.1775218 L19.5168642,54 L34.7563536,31.8591974 C35.3036736,31.1694298 35.8050003,30.4424404 36.2572675,29.6782291 L36.411345,29.4556734 L36.3860487,29.4556734 C38.0456395,26.5655511 39,23.2148083 39,19.6364694' id='Shape'/%3E%3C/g%3E%3C/g%3E%3Ctext xmlns='http://www.w3.org/2000/svg' id='97' font-family='Sans-Serif' font-size='12' width='30px' font-weight='bold' letter-spacing='-0.133333335' fill='%23737373' style='&%2310;'%3E%3Ctspan xmlns='http://www.w3.org/2000/svg' x='19.1' text-anchor='middle' y='24' style='&%2310;'%3E" +
                            iconNumber +
                            '%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E'
                    };

                    // setup click event for markers
                    google.maps.event.addListener(marker, 'click', function () {
                        // close all infowindows and set active states to false
                        for (let i = 0; i < infoWindows.length; i++) {
                            var iconNumber = i + 1;
                            var icon = {
                                scaledSize: new google.maps.Size(39, 54),
                                url:
                                    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='39px' height='54px' viewBox='0 0 39 54' version='1.1'%3E%3C!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3E%3Ctitle%3EGroup 13%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Welcome' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Desktop-HD-Copy' transform='translate(-805.000000, -662.000000)'%3E%3Cg id='Group-13' transform='translate(805.000000, 662.000000)'%3E%3Cg id='Group-11'%3E%3Cg id='Oval-2' transform='translate(10.000000, 10.000000)' fill='%23FFFFFF' stroke='%23979797'%3E%3Ccircle id='Oval' cx='9.5' cy='9.5' r='9.5'/%3E%3C/g%3E%3Cg id='Group-12'%3E%3Cg xmlns='http://www.w3.org/2000/svg' id='iconfinder_94_171453' fill='%23" +
                                    vm.siteContent.site.pages.directory.iconColor +
                                    "' text-anchor='middle' fill-rule='nonzero'%3E%3Cg id='Shape-2'%3E%3Cpath d='M28.7368421,19.7307692 C28.7368421,24.8906788 24.60136,29.0769231 19.5,29.0769231 C14.3979138,29.0769231 10.2631579,24.8906788 10.2631579,19.7307692 C10.2631579,14.5693833 14.39864,10.3846154 19.5,10.3846154 C24.6024493,10.3842463 28.7368421,14.5690142 28.7368421,19.7307692 M39,19.6364694 C39,8.79133788 30.2700926,0 19.5,0 C8.73067398,0 0,8.79133788 0,19.6364694 C0,24.4047446 1.68948641,28.7767622 4.49699275,32.1775218 L19.5168642,54 L34.7563536,31.8591974 C35.3036736,31.1694298 35.8050003,30.4424404 36.2572675,29.6782291 L36.411345,29.4556734 L36.3860487,29.4556734 C38.0456395,26.5655511 39,23.2148083 39,19.6364694' id='Shape'/%3E%3C/g%3E%3C/g%3E%3Ctext xmlns='http://www.w3.org/2000/svg' id='97' font-family='Sans-Serif' font-size='12' width='30px' font-weight='bold' letter-spacing='-0.133333335' fill='%23737373' style='&%2310;'%3E%3Ctspan xmlns='http://www.w3.org/2000/svg' x='19.1' text-anchor='middle' y='24' style='&%2310;'%3E" +
                                    iconNumber +
                                    '%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E'
                            };
                            infoWindows[i].close();
                            addressData[i].data.active = false;
                            markers[i].setIcon(icon);
                        }

                        markers[i].setIcon(activeIcon);

                        // set the selected listing to active
                        addressData[i].data.active = true;

                        // open infowindow for the clicked marker
                        infowindow.open(map, marker);

                        // scroll to active listing
                        var elem = document.getElementById('dentist-' + i).offsetTop;
                        var cont = document.getElementById('dentists-listings').offsetTop;
                        scrollTo(document.getElementById('dentists-listings'), elem - cont, 400, i);
                    });

                    // infowindow close button event
                    google.maps.event.addListener(infowindow, 'closeclick', function () {
                        // set active states to false
                        for (let i = 0; i < infoWindows.length; i++) {
                            addressData[i].data.active = false;
                            var iconNumber = i + 1;
                            var activeIcon = {
                                url:
                                    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='39px' height='54px' viewBox='0 0 39 54' version='1.1'%3E%3C!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3E%3Ctitle%3EGroup 13%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Welcome' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Desktop-HD-Copy' transform='translate(-805.000000, -662.000000)'%3E%3Cg id='Group-13' transform='translate(805.000000, 662.000000)'%3E%3Cg id='Group-11'%3E%3Cg id='Oval-2' transform='translate(10.000000, 10.000000)' fill='%23FFFFFF' stroke='%23979797'%3E%3Ccircle id='Oval' cx='9.5' cy='9.5' r='9.5'/%3E%3C/g%3E%3Cg id='Group-12'%3E%3Cg xmlns='http://www.w3.org/2000/svg' id='iconfinder_94_171453' fill='%23" +
                                    vm.siteContent.site.pages.directory.iconColor +
                                    "' text-anchor='middle' fill-rule='nonzero'%3E%3Cg id='Shape-2'%3E%3Cpath d='M28.7368421,19.7307692 C28.7368421,24.8906788 24.60136,29.0769231 19.5,29.0769231 C14.3979138,29.0769231 10.2631579,24.8906788 10.2631579,19.7307692 C10.2631579,14.5693833 14.39864,10.3846154 19.5,10.3846154 C24.6024493,10.3842463 28.7368421,14.5690142 28.7368421,19.7307692 M39,19.6364694 C39,8.79133788 30.2700926,0 19.5,0 C8.73067398,0 0,8.79133788 0,19.6364694 C0,24.4047446 1.68948641,28.7767622 4.49699275,32.1775218 L19.5168642,54 L34.7563536,31.8591974 C35.3036736,31.1694298 35.8050003,30.4424404 36.2572675,29.6782291 L36.411345,29.4556734 L36.3860487,29.4556734 C38.0456395,26.5655511 39,23.2148083 39,19.6364694' id='Shape'/%3E%3C/g%3E%3C/g%3E%3Ctext xmlns='http://www.w3.org/2000/svg' id='97' font-family='Sans-Serif' font-size='12' width='30px' font-weight='bold' letter-spacing='-0.133333335' fill='%23737373' style='&%2310;'%3E%3Ctspan xmlns='http://www.w3.org/2000/svg' x='19.1' text-anchor='middle' y='24' style='&%2310;'%3E" +
                                    iconNumber +
                                    '%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E'
                            };
                            markers[i].setIcon(activeIcon);
                        }
                    });

                    markers.push(marker);
                });
            }

            if (map.getZoom() >= 11) {
                createMarkers(getPoints());
            }

            setTimeout(function () {
                geolocate();
            }, 1500);
        }

        // filter markers based on location
        function filterMarkers(locationCoords) {
            if (locationCoords) {
                var markers_filtered = markers.filter(function (marker, index, array) {
                    var markerLatLng = new window.google.maps.LatLng(marker.position.lat(), marker.position.lng());
                    var distance =
                        google.maps.geometry.spherical.computeDistanceBetween(locationCoords, markerLatLng) *
                        0.000621371192;

                    // set distance away on listing
                    $scope.addressData[index].distance = Math.round(distance * 100) / 100;

                    var distanceMultiplier = 1609.344000614692 * milesSelection;

                    if (
                        google.maps.geometry.spherical.computeDistanceBetween(locationCoords, markerLatLng) <
                        distanceMultiplier
                    ) {
                        $scope.addressData[index].hide = true;
                    } else {
                        $scope.addressData[index].hide = false;
                    }
                    return (
                        google.maps.geometry.spherical.computeDistanceBetween(locationCoords, markerLatLng) <
                        distanceMultiplier
                    );
                });
            } else {
                // handle reset maps - show all listings
                console.log('Resetting listings');
                for (var i = 0; i < $scope.addressData.length; i++) {
                    $scope.addressData[i].data.hide = false;
                }
            }
        }

        // clear map zoom
        function resetMap() {
            map.fitBounds(bounds);
            filterMarkers(null);
        }

        // on find autocomplete button click
        function triggerAc() {
            if (autocomplete.getPlace()) {
                // if autocomplete location is selected
                google.maps.event.trigger(autocomplete, 'place_changed');
            }
        }

        // on listing click
        function triggerClick(i) {
            google.maps.event.trigger(markers[i], 'click');
        }

        // scroll to selected listing
        function scrollTo(element, to, duration) {
            var start = element.scrollTop,
                change = to - start,
                currentTime = 0,
                increment = 20;

            var animateScroll = function () {
                currentTime += increment;
                var val = Math.easeInOutQuad(currentTime, start, change, duration);
                element.scrollTop = val;
                if (currentTime < duration) {
                    setTimeout(animateScroll, increment);
                }
            };
            animateScroll();
        }

        // scroll animation timing
        Math.easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1) return (c / 2) * t * t + b;
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        };
    }
})(angular);
